module.exports = __webpack_public_path__ + "app/img/logo.bf4a47d8.png";